export type Language = "en" | "de";

export function browserLanguage(): Language {
  if (typeof navigator === "undefined") return "en";
  const preferences = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const preference of preferences) {
    const primary = preference.toLowerCase().split(/[-_]/)[0];
    if (primary === "de" || primary === "en") return primary;
  }
  return "en";
}

export function preferredCustomerLanguage(): Language {
  const query = new URLSearchParams(window.location.search).get("lang");
  if (query === "en" || query === "de") return query;
  try {
    const saved = localStorage.getItem("bookish.interfaceLanguage");
    if (saved === "en" || saved === "de") return saved;
  } catch { /* Browser storage may be unavailable. */ }
  return browserLanguage();
}

export function requestLanguage(): Language {
  if (/^\/admin(?:\/|$)/i.test(window.location.pathname)) return "en";
  return preferredCustomerLanguage();
}

export function localizedLoginUrl(base: string | undefined): string {
  return `${base}/login${requestLanguage() === "de" ? "?lang=de" : ""}`;
}
